(window as typeof window & { __PAGE_2026_LOADED__?: boolean }).__PAGE_2026_LOADED__ = true;

import "../styles/index.scss";

import {
  Application,
  ApplicationComponentData,
  ApplicationComponentDatasetData,
  ApplicationRoute,
  Component,
  ComponentParameters,
  Page,
  PageParameters,
} from "@lisergia/core";

Application.IS_LINKS_ENABLED = false;

import { configure } from "mobx";

configure({
  enforceActions: "never",
});

import Activities from "./datasets/Activities";
import Bento from "./datasets/Bento";
import Carousel from "./datasets/Carousel";
import Character from "./datasets/Character";
import Fade from "./datasets/Fade";
import FoundationItem from "./datasets/FoundationItem";
import MenuButtonVideo from "./datasets/MenuButtonVideo";
import HeaderSprite from "./datasets/HeaderSprite";
import Mouse from "./datasets/Mouse";
import Navigation from "./datasets/Navigation";
import Parallax from "./datasets/Parallax";
import RiveAnnouncement from "./datasets/RiveAnnouncement";
import Search from "./datasets/Search";
import Source from "./datasets/Source";
import Sticky from "./datasets/Sticky";

import { initModal } from "../lib/modal";

import "./event-tracker";

import Standard from "./page/Standard";

const components: Array<ApplicationComponentData> = [
  {
    component: Navigation as new (params?: ComponentParameters) => Component,
  },
];

const datasets: Array<ApplicationComponentDatasetData> = [
  {
    component: Activities as new (params?: ComponentParameters) => Component,
    selector: ".activities",
  },
  {
    component: Bento as new (params?: ComponentParameters) => Component,
    selector: ".bento",
  },
  {
    component: Carousel as new (params?: ComponentParameters) => Component,
    selector: "[data-carousel]",
  },
  {
    component: Character as new (params?: ComponentParameters) => Component,
    selector: "[data-character]",
  },
  {
    component: Fade as new (params?: ComponentParameters) => Component,
    selector: "[data-fade]",
  },
  {
    component: FoundationItem as new (
      params?: ComponentParameters,
    ) => Component,
    selector: ".foundation__item",
  },
  {
    component: HeaderSprite as new (params?: ComponentParameters) => Component,
    selector: "[data-header-sprite]",
  },
  {
    component: Mouse as new (params?: ComponentParameters) => Component,
    selector: ".gameplay__mouse",
  },
  {
    component: Parallax as new (params?: ComponentParameters) => Component,
    selector: "[data-parallax]",
  },
  {
    component: RiveAnnouncement as new (params?: ComponentParameters) => Component,
    selector: "[data-rive-announcement]",
  },
  {
    component: Search as new (params?: ComponentParameters) => Component,
    selector: "[data-search]",
  },
  {
    component: Source as new (params?: ComponentParameters) => Component,
    selector: "video[data-src]",
  },
  {
    component: Sticky as new (params?: ComponentParameters) => Component,
    selector: "[data-sticky]",
  },
];

const routes: Array<ApplicationRoute> = [
  {
    component: Standard as new (params?: PageParameters) => Page,
    template: "page",
  },
  {
    component: Standard as new (params?: PageParameters) => Page,
    template: "404",
  },
];

document.querySelectorAll("[data-menu-button]").forEach((element) => {
  const instance = new MenuButtonVideo({ element: element as HTMLElement });
  Application.addComponent(instance as InstanceType<typeof Component>);
});

Application.initRoutes(routes);
Application.initDatasets(datasets);
Application.initPage();
Application.initComponents(components);

document.documentElement.classList.add("loaded");

const WINDOW = window as typeof window & { Application: typeof Application };

WINDOW.Application = Application;

initModal();